import request from "@/utils/request"
import {ADMIN_URL} from "@/utils/constant"
export function getTripList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/gettriplist`,
    method: 'post',
    params:{
      page:currentPage,
      limit:pageSize,
      ...params
    }
  })
}

export function getTripInfo(params) {
  return request({
    url: `${ADMIN_URL}/gettriphandleinfo`,
    method: 'get',
    params
  })
}

export function doTripHandle(data) {
  return request({
    url: `${ADMIN_URL}/dotriphandle`,
    method: 'post',
    params:data
  })
}
